import { Module } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: AuthState = {
    isAuthenticated: false,
    status: '',
    isNeedChangePassword: JSON.parse(localStorage.getItem('lk-incp') || 'false'),
    username: localStorage.getItem('lk-username') || '',
    moderationSettings: JSON.parse(localStorage.getItem('lk-moderation') || '[]'),
    isADUser: JSON.parse(localStorage.getItem('lk-isADUser') || 'false'),
};

const namespaced: boolean = false;

export const auth: Module<AuthState,RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};